import styled from 'styled-components';

export const StyledDefaultBalance = styled.div`
    display: inline-flex;
    align-items: center;
    margin-right: 4px;
    font-weight: ${({ playerName }: any) => (playerName ? 'inherit' : '600')};

    .balance {
        &__img {
            height: 16px;
            width: 16px;
            margin-right: 0.5em;
            background-color: transparent;
        }
        &__text {
            font-size: 14px;
        }
    }
` as any;
